import React from 'react'
import { useState } from 'react'

export type FooterProps = {
    isNew?: boolean // footer new 버전 (메인 개편)
}

function Footer({ isNew }: FooterProps) {
    const [isExpand, setIsExpand] = useState(false)

    return (
        <footer className="footer">
            <p className="copyright">© WOONGJIN THINKBIG</p>
            {isNew && (
                <>
                    <button
                        type="button"
                        className={
                            isExpand ? 'btn-coinfo active' : 'btn-coinfo'
                        }
                        onClick={() => setIsExpand(!isExpand)}
                    >
                        <span className="_hidden">펼치기/접기</span>
                    </button>

                    <div className={isExpand ? 'coinfo active' : 'coinfo'}>
                        <div className="coinfo-logo">
                            <span className="_hidden">웅진씽크빅</span>
                        </div>
                        <address className="coinfo-addr">
                            <div>
                                주소 : (10881) 경기도 파주시 회동길 20
                                (주)웅진씽크빅
                            </div>
                            <div>
                                대표이사 : 이봉주
                                <hr className="divider-v" />
                                사업자등록번호 : 141-81-09131
                            </div>
                            <div>
                                COPYRIGHT © WOONGJIN THINKBIG. ALL RIGHTS
                                RESERVED.
                            </div>
                        </address>
                    </div>
                </>
            )}
        </footer>
    )
}

export default Footer
